<template>
  <p class="text-sm opacity-90">
    <slot></slot>
  </p>
</template>
